import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

export default function RWD_Templates() {
  return (
    <div className="tutorial-container">
      {/* Hero Section */}
      <div
        style={{
          background: "linear-gradient(135deg, #60a5fa, #3b82f6)",
          color: "white",
          padding: "2rem",
          borderRadius: "16px",
          marginBottom: "2rem",
          textAlign: "center",
        }}
      >
        <h1 style={{ fontSize: "2.5rem", fontWeight: "bold" }}>
          📄 RWD Templates
        </h1>
        <p style={{ fontSize: "1.2rem", marginTop: "1rem" }}>
          Responsive templates provide ready-made layouts that adapt to
          different devices, saving time and ensuring a consistent user
          experience.
        </p>
        <img
          src="https://www.w3schools.com/w3images/lights.jpg"
          alt="Responsive Template Example"
          style={{
            maxWidth: "500px",
            margin: "1.5rem auto 0",
            borderRadius: "12px",
            boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
          }}
        />
      </div>

      {/* Intro */}
      <p className="tutorial-intro">
        Responsive templates often include prebuilt sections, headers, footers,
        cards, and galleries. They leverage CSS Grid, Flexbox, and frameworks to
        automatically adjust layouts for desktops, tablets, and mobile devices.
      </p>

      {/* Key Points */}
      <div
        style={{
          background: "linear-gradient(135deg, #fef3c7, #fde68a)",
          padding: "1.2rem",
          paddingLeft: "35px",
          borderRadius: "12px",
          marginBottom: "2rem",
        }}
      >
        <h2 style={{ color: "#92400e" }}>🔑 Key Points</h2>
        <ul className="tutorial-list-points">
          <li>Templates provide ready-to-use layouts for fast development.</li>
          <li>
            Responsive templates adapt automatically using media queries, grids,
            or flex layouts.
          </li>
          <li>
            They include common sections like headers, footers, cards, and
            galleries.
          </li>
          <li>Can be customized using your own CSS or framework utilities.</li>
          <li>
            Ensure cross-device compatibility by testing on multiple screen
            sizes.
          </li>
        </ul>
      </div>

      {/* Example 1: Simple Card Template */}
      <h2 className="section-title">1️⃣ Simple Card Template</h2>
      <CodeCopyBlock
        code={`<div class="card-container">
  <div class="card">Card 1</div>
  <div class="card">Card 2</div>
  <div class="card">Card 3</div>
</div>

.card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.card {
  flex: 1 1 200px;
  padding: 20px;
  background: #3b82f6;
  color: white;
  border-radius: 10px;
}`}
      />
      <p>✅ Responsive card layout that adapts to screen width.</p>

      {/* Example 2: Header + Content + Footer Template */}
      <h2 className="section-title">2️⃣ Header + Content + Footer Template</h2>
      <CodeCopyBlock
        code={`<header class="header">Header</header>
<main class="content">Main Content</main>
<footer class="footer">Footer</footer>

.header, .footer {
  background: #2563eb;
  color: white;
  padding: 20px;
  text-align: center;
}

.content {
  padding: 20px;
}`}
      />
      <p>✅ Standard template structure for websites, fully responsive.</p>

      {/* Example 3: Grid-Based Template */}
      <h2 className="section-title">3️⃣ Grid-Based Template</h2>
      <CodeCopyBlock
        code={`.grid-template {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
}

.grid-template div {
  background: #10b981;
  padding: 20px;
  color: white;
  border-radius: 8px;
}`}
      />
      <p>
        ✅ Grid template adjusts number of columns automatically based on screen
        size.
      </p>
      <div
        className="grid-template"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
          gap: "10px",
          marginBottom: "2rem",
        }}
      >
        <div>Section 1</div>
        <div>Section 2</div>
        <div>Section 3</div>
        <div>Section 4</div>
      </div>

      {/* Next Steps */}
      <div
        style={{
          background: "linear-gradient(135deg, #dbeafe, #bfdbfe)",
          padding: "1.2rem",
          paddingLeft: "35px",
          borderRadius: "12px",
          marginBottom: "2rem",
        }}
      >
        <h2 style={{ color: "#1e3a8a" }}>🚀 Next Steps</h2>
        <ul className="tutorial-list-points">
          <li>
            Experiment with card and grid templates for different content types.
          </li>
          <li>
            Combine templates with CSS Grid and Flexbox for complex layouts.
          </li>
          <li>
            Customize colors, spacing, and typography to match your design.
          </li>
          <li>
            Test templates on mobile, tablet, and desktop for full
            responsiveness.
          </li>
          <li>
            Integrate framework classes (Bootstrap, Tailwind) for faster
            development.
          </li>
        </ul>
      </div>
    </div>
  );
}
